<script>
  export default {
    name: 'AddressFunctionality',
    props: {
      zip: String,
      area: Object,
      city: Object,
      street: Object,
      house: Object,
      apartment: String,
    },
    data: () => ({
      zipMask: '42####',

      areaTmp: null,
      cityTmp: null,
      streetTmp: null,

      areaList: [],
      cityList: [],
      streetList: [],
      houseList: [],

      areaLoading: false,
      cityLoading: false,
      streetLoading: false,
      houseLoading: false
    }),
    watch: {
      area: {
        immediate: true,
        handler (value) {
          if (value && !value.fromInner && (!this.areaTmp || value.value !== this.areaTmp.value)) {
            if (value.isCity) {
              this.request('street', {cityCode: value.value})
            } else
              this.request('city', {areaCode: value.value})
          }
          this.areaTmp = value
        }
      },
      city: {
        immediate: true,
        handler (value) {
          if (value && !value.fromInner && (!this.cityTmp || value.value !== this.cityTmp.value)) {
            this.request('street', {cityCode: value.value})
          }
          this.cityTmp = value
        }
      },
      street: {
        immediate: true,
        handler (value) {
          if (value && value.value && !value.fromInner && (!this.streetTmp || value.value !== this.streetTmp.value)) {
            this.request('house', {streetCode: value.value})
          }
          this.streetTmp = value
        }
      },
    },
    methods: {
      assemblyData () {
        return {
          zip: this.zip,
          area: this.area,
          city: this.city,
          street: this.street,
          house: this.house,
          apartment: this.apartment
        }
      },
      assemblyListeners () {
        return {
          changeZip: this.changeZip,
          changeArea: this.changeArea,
          changeCity: this.changeCity,
          changeStreet: this.changeStreet,
          changeHouse: this.changeHouse,
          changeApartment: this.changeApartment
        }
      },
      assemblyLists () {
        return {
          areaList: this.areaList,
          cityList: this.cityList,
          streetList: this.streetList,
          houseList: this.houseList
        }
      },
      assemblyLoadings () {
        return {
          areaLoading: this.areaLoading,
          cityLoading: this.cityLoading,
          streetLoading: this.streetLoading,
          houseLoading: this.houseLoading,
        }
      },

      changeZip (value) {
        this.$emit('change-zip', value)
      },
      changeArea (value) {
    //    console.log(value);
        this.$emit('change-area', value)

        this.clear(['city', 'street', 'house', 'apartment'])
        this.clearList(['cityList', 'streetList', 'houseList'])

         if (value.isCity){
           this.request('street', {cityCode: value.value})}
         else
           this.request('city', {areaCode: value.value})
      },
      changeCity (value) {
        value.fromInner = true
        this.$emit('change-city', value)

        this.clear(['street', 'house', 'apartment'])
        this.clearList(['streetList', 'houseList'])

        // this.request('street', {cityCode: value.value})
      },
      changeStreet (value) {
        value.fromInner = true
        this.$emit('change-street', value)

        this.clear(['house', 'apartment'])
        this.clearList(['houseList'])

        // this.request('house', {streetCode: value.value})
      },
      changeHouse (value) {
        value.fromInner = true

        this.clear(['apartment'])

        this.$emit('change-house', value)
        this.$emit('change-zip', value.socr)
      },
      changeApartment (value) {
        this.$emit('change-apartment', value)
      },

      clear (fields) {
        fields.forEach(val => {
          const CHANGE_NAME = 'change-' + val[0] + val.slice(1)
          if (this[val])
            this.$emit(CHANGE_NAME, null)
        })
      },

      clearList(fields) {
        fields.forEach(val => {
          this[val] = null
        })
      },

      request (type, data) {
        // console.log(type)
        const LOADING = type + 'Loading'
        const LIST = type + 'List'

        this[LOADING] = true
        return this.$store.dispatch('statements/getFias', data)
          .then((response) => {
            this[LIST] = response.data.fias
            this[LOADING] = false
          })
      },
    },
    created () {
      this.request('area', {})
    },
    render () {
      return this.$scopedSlots.default({
        zipMask: this.zipMask,
        data: this.assemblyData(),
        listeners: this.assemblyListeners(),
        lists: this.assemblyLists(),
        loading: this.assemblyLoadings()
      })
    }
  }
</script>

<style scoped>

</style>
